module.exports = __webpack_public_path__ + "static/media/party1.cb074dda.jpeg";